// src/components/AnimatedPipelineWorkflow.tsx
import React, { useEffect, useState } from "react";
import "./AnimatedPipelineWorkflow.css";
import { User2, GitPullRequest, FolderGit2, Loader } from "lucide-react";
import { SiGithub, SiGitea } from "react-icons/si";
import { Cog } from "lucide-react"; // For Pipelyze engine icon

export default function AnimatedPipelineWorkflow() {
  // Animate repo analyzing -> completion
  const [repoDone, setRepoDone] = useState([false, false, false]);
  useEffect(() => {
    const timeouts = [900, 1600, 2100].map((delay, i) =>
      setTimeout(() => setRepoDone((old) => {
        const n = [...old];
        n[i] = true;
        return n;
      }), delay)
    );
    return () => timeouts.forEach(clearTimeout);
  }, []);

  return (
    <div className="apw-root">
      <h3 className="apw-title">How Pipelyze Automates Your Workflow</h3>
      <div className="apw-grid">
        {/* Developer */}
        <div className="apw-col apw-card">
          <div className="apw-card-icon">
            <User2 size={54} strokeWidth={2} />
          </div>
          <div className="apw-card-label">You</div>
        </div>
        {/* Arrow to Pipelyze */}
        <div className="apw-arrow-col">
          <svg className="apw-arrow apw-arrow-animate" width="64" height="24">
            <polyline points="4,12 60,12" stroke="#ac8bfa" strokeWidth="4" fill="none" strokeLinecap="round" />
            <polygon points="54,8 64,12 54,16" fill="#ac8bfa" />
          </svg>
        </div>
        {/* Pipelyze Card */}
        <div className="apw-col pipelyze-card">
          <div className="pipelyze-logo-row">
            <img src="/logo_only_256x256.png" alt="Pipelyze Logo" className="pipelyze-logo-img" />
            <span className="pipelyze-card-title">Pipelyze</span>
          </div>
          <div className="engine-spin">
            <Cog size={38} strokeWidth={2.2} />
          </div>
          <div className="pipelyze-card-desc">AI analyzes your repos<br />Generates pipelines &amp; tests</div>
        </div>
        {/* Arrow back for PR */}
        <div className="apw-arrow-col">
          <svg className="apw-arrow apw-arrow-animate rev" width="64" height="24">
            <polyline points="60,12 4,12" stroke="#ac8bfa" strokeWidth="4" fill="none" strokeLinecap="round" />
            <polygon points="10,8 0,12 10,16" fill="#ac8bfa" />
          </svg>
        </div>
        {/* PR Card */}
        <div className="apw-col apw-card">
          <div className="apw-card-icon">
            <GitPullRequest size={54} strokeWidth={2} />
          </div>
          <div className="apw-card-label">Pull Request</div>
        </div>
      </div>
      {/* Providers below, animated up to Pipelyze */}
      <div className="apw-providers-row">
        <div className="provider-icn">
          <SiGithub size={36} color="white" style={{ marginBottom: 2 }} />
          <span>GitHub</span>
        </div>
        <div className="provider-arrow">
          <svg className="apw-provider-arrow-animate" width="44" height="32">
            <polyline points="22,28 22,4" stroke="#ac8bfa" strokeWidth="3" fill="none" strokeLinecap="round" />
            <polygon points="18,10 22,0 26,10" fill="#ac8bfa" />
          </svg>
        </div>
        <div className="provider-icn">
          <SiGitea size={36} color="#609926" style={{ marginBottom: 2 }} />
          <span>Gitea</span>
        </div>
      </div>
      {/* Animated repos list */}
      <div className="apw-repos-list">
        <div className="repo-analyzing">Analyzing Repositories...</div>
        <div className="repo-cards">
          {[1, 2, 3].map((i, idx) => (
            <div className="repo-card" key={i}>
              <span className="repo-icon">
                <FolderGit2 size={32} strokeWidth={2.2} className="repo-folder-icon" />
              </span>
              <span>repo-{i}</span>
              {!repoDone[idx] ? (
                <span className="dot-loader">
                  <span className="dot dot1"></span>
                  <span className="dot dot2"></span>
                  <span className="dot dot3"></span>
                </span>
              ) : (
                <span className="checkmark-anim">
                  <svg width="28" height="24" viewBox="0 0 28 24">
                    <polyline
                      points="4,14 12,20 24,6"
                      fill="none"
                      stroke="#24d587"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="checkmark-path"
                    />
                  </svg>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
